import React, { useEffect, useState } from "react";
import { Formik, FieldArray, Field } from "formik";
import Swal from "sweetalert2";
import * as globalSettingsService from "../../../services/globalsetting.services";
import Breadcrums from "../../../common/breadcrumbs";
import {
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import Loader from "../../../common/loader";
import { URL_REGEX, MOBILE_NUMBER_REGEX } from "../../../../../utils/Constants";
import { useTranslation } from "react-i18next";

const VERSION_REGEX = /^\d+(\.\d+){1,3}$/;

const GlobalSettings = (props) => {
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: t("sidebar_link_global_settings"), url: "" },
  ];

  useEffect(() => {
    globalSettingsService
      .Details()
      .then((response) => {
        setShowDefault(response && response.data ? response?.data : []);
        setTimeout(() => {
          setDataLoaded(true);
        }, 100);
      })
      .catch((error) => {
        console.log("error=====>", error);
        setDataLoaded(true);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      {dataLoaded ? (
        <Formik
          validateOnChange={true}
          enableReinitialize
          initialValues={{
            Address: showdefault && showdefault.address ? showdefault.address : "",
            AdminEmail: showdefault && showdefault.admin_email ? showdefault.admin_email : "",
            Contact: showdefault && showdefault.phone_number ? showdefault.phone_number : "",
            CopyRighttxt: showdefault && showdefault.copy_right_text ? showdefault.copy_right_text : "",
            web: showdefault && showdefault.website ? showdefault.website : "",
            play_store_url: showdefault && showdefault.play_store_url ? showdefault.play_store_url : "",
            app_store_url: showdefault && showdefault.app_store_url ? showdefault.app_store_url : "",
            min_android_version: showdefault && showdefault.min_android_version ? showdefault.min_android_version : "",
            current_android_version: showdefault && showdefault.current_android_version ? showdefault.current_android_version : "",
            min_ios_version: showdefault && showdefault.min_ios_version ? showdefault.min_ios_version : "",
            current_ios_version: showdefault && showdefault.current_ios_version ? showdefault.current_ios_version : "",
            android_force_update: showdefault && showdefault.android_force_update === true,
            ios_force_update: showdefault && showdefault.ios_force_update === true,
            title: showdefault && showdefault.title ? showdefault.title : "",
            socialMedia: showdefault && showdefault.social_media_details && showdefault?.social_media_details?.length ? showdefault.social_media_details : [{ title: '', link: '', icon: '' }],
            baeMedia: showdefault && showdefault.bae_media_details && showdefault?.bae_media_details?.length ? showdefault.bae_media_details : [{ title: "" }],
            is_buy_rent: showdefault && showdefault.is_buy_rent === true,
          }}
          validate={(values) => {
            let error = { socialMedia: [], baeMedia: [] };
            if (values?.socialMedia?.length > 0) {
              values?.socialMedia.forEach((element, i) => {
                error.socialMedia[i] = {};
                if (!element.title) {
                  error.socialMedia[i]["title"] = t("validation_err_title_required");
                }
                if (element.title.length > 20) {
                  error.socialMedia[i]["title"] = t("validation_err_reached_maximum_length");
                }
                if (!element.icon) {
                  error.socialMedia[i]["icon"] = t("validation_err_icon_required");
                } else if (!/^<i\s+[^>]*\/>$|^<i\s+[^>]*><\/i>$/.test(element.icon.trim())) {
                  error.socialMedia[i]["icon"] = t("validation_err_icon_invalid");
                } else if (element.icon.length > 50) {
                  error.socialMedia[i]["icon"] = t("validation_err_reached_maximum_length");
                }
                if (!element.link) {
                  error.socialMedia[i]["link"] = t("validation_err_link_required");
                }
                if (element.link.length > 50) {
                  error.socialMedia[i]["link"] = t("validation_err_reached_maximum_length");
                } else if (!URL_REGEX.test(element.link)) {
                  error.socialMedia[i]["link"] = t("invalid_web_url");
                }
              });
            }
            if (error.socialMedia.length) {
              let socialMediaFlag = 0;
              error.socialMedia.forEach((element, i) => {
                if (Object.keys(element).length) {
                  socialMediaFlag++;
                }
              });
              if (!socialMediaFlag) {
                delete error.socialMedia;
              }
            } else {
              delete error.socialMedia;
            }

            // baeMedia title only validation
            if (values?.baeMedia?.length > 0) {
              values?.baeMedia.forEach((element, i) => {
                error.baeMedia[i] = {};
                if (!element?.title?.trim()) {
                  error.baeMedia[i]["title"] = t("validation_err_title_required");
                } else if (element.title.length > 500) {
                  error.baeMedia[i]["title"] = t("validation_err_reached_maximum_length_500");
                }
              });
            }

            if (error.baeMedia.length) {
              let baeMediaFlag = 0;
              error.baeMedia.forEach((element) => {
                if (Object.keys(element).length) {
                  baeMediaFlag++;
                }
              });
              if (!baeMediaFlag) {
                delete error.baeMedia;
              }
            } else {
              delete error.baeMedia;
            }

            if (!values.AdminEmail.trim()) {
              error.AdminEmail = t("label_email_error");
            } else if (!/^[A-Z0-9._%+-+@ [A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.AdminEmail)) {
              error.AdminEmail = t("invalid_email");
            }
            if (!String(values.Contact).trim()) {
              error.Contact = t("label_phone_number_required_error");
            } else if (!MOBILE_NUMBER_REGEX.test(values.Contact)) {
              error.Contact = t("label_contact_invalid_error");
            }
            if (!values.CopyRighttxt.trim()) {
              error.CopyRighttxt = t("copyright_error");
            } else if (values.CopyRighttxt.trim().length > 100) {
              error.CopyRighttxt = t("copyright_max_length_error");
            }
            if (!values.Address.trim()) {
              error.Address = t("label_location_error");
            } else if (values.Address.length > 500) {
              error.Address = t("validation_err_reached_maximum_length");
            }
            if (!values.web.trim()) {
              error.web = t("website_error");
            } else if (!URL_REGEX.test(values.web)) {
              error.web = t("invalid_web_url");
            }
            if (!values.play_store_url.trim()) {
              error.play_store_url = "Play Store URL is required";
            } else if (!URL_REGEX.test(values.play_store_url)) {
              error.play_store_url = t("invalid_web_url");
            }
            if (!values.app_store_url.trim()) {
              error.app_store_url = "App Store URL is required";
            } else if (!URL_REGEX.test(values.app_store_url)) {
              error.app_store_url = t("invalid_web_url");
            }
            ["min_android_version", "current_android_version", "min_ios_version", "current_ios_version"].forEach((key) => {
              const v = (values[key] || "").trim();
              if (!v) {
                error[key] = "Version is required";
              } else if (!VERSION_REGEX.test(v)) {
                error[key] = "Invalid version format (e.g. 1.0.0)";
              }
            });
            if (!values.title.trim()) {
              error.title = t("label_title_error");
            } else if (values.title.trim().length > 50) {
              error.title = t("label_title_length_error_50");
            }

            return error;
          }}
          onSubmit={(values) => {
            setSubmitted(true);
            let formData = new FormData();
            formData.append("address", values.Address);
            formData.append("website", values.web);
            formData.append("play_store_url", values.play_store_url);
            formData.append("app_store_url", values.app_store_url);
            formData.append("min_android_version", values.min_android_version);
            formData.append("current_android_version", values.current_android_version);
            formData.append("min_ios_version", values.min_ios_version);
            formData.append("current_ios_version", values.current_ios_version);
            formData.append("android_force_update", values.android_force_update);
            formData.append("ios_force_update", values.ios_force_update);
            formData.append("admin_email", values.AdminEmail);
            formData.append("social_media_details", JSON.stringify(values.socialMedia));
            formData.append("bae_media_details", JSON.stringify(values.baeMedia));
            formData.append("phone_number", values.Contact);
            formData.append("copy_right_text", values.CopyRighttxt);
            formData.append("title", values.title);
            formData.append("is_buy_rent", values.is_buy_rent);
            globalSettingsService.Add(formData).then((response) => {
              if (response.success) {
                Swal.fire({
                  icon: "success",
                  text: response.message,
                  ...SWAL_SETTINGS,
                });
              } else {
                Swal.fire({
                  icon: "error",
                  text: handleServerValidations(response),
                  ...SWAL_SETTINGS,
                });
              }
              setSubmitted(false);
            }).catch((error) => {
              console.log("error", error);
              setSubmitted(false);
            });
          }}
        >
          {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                  <div className="card custom-card">
                    <div className="card-body">
                      <h6 className="main-content-label mb-3">{t("sidebar_link_global_settings")}</h6>
                      <div className="row row-sm">
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            {t("role_super_admin")} {t("label_email")}:<span className="requirestar">*</span>
                          </label>
                          <input name="AdminEmail" type="text" className="form-control" onChange={handleChange} onBlur={handleBlur} value={values.AdminEmail} />
                          <span className="text-danger">{errors.AdminEmail && touched.AdminEmail && errors.AdminEmail}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            {t("label_contact_no")}:<span className="requirestar">*</span>
                          </label>
                          <input name="Contact" type="number" className="form-control" onChange={handleChange} onBlur={handleBlur} value={values.Contact} />
                          <span className="text-danger">{errors.Contact && touched.Contact && errors.Contact}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            {t("list_heading_address")}:<span className="requirestar">*</span>
                          </label>
                          <textarea name="Address" className="form-control" style={{ minHeight: "100px" }} onChange={handleChange} onBlur={handleBlur} value={values.Address} />
                          <span className="text-danger">{errors.Address && touched.Address && errors.Address}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            {t("label_website")}:<span className="requirestar">*</span>
                          </label>
                          <input name="web" className="form-control" onChange={handleChange} onBlur={handleBlur} value={values.web} />
                          <span className="text-danger">{errors.web && touched.web && errors.web}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            Play Store URL:<span className="requirestar">*</span>
                          </label>
                          <input name="play_store_url" className="form-control" placeholder="https://play.google.com/store/apps/details?id=..." onChange={handleChange} onBlur={handleBlur} value={values.play_store_url} />
                          <span className="text-danger">{errors.play_store_url && touched.play_store_url && errors.play_store_url}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            App Store URL:<span className="requirestar">*</span>
                          </label>
                          <input name="app_store_url" className="form-control" placeholder="https://apps.apple.com/app/..." onChange={handleChange} onBlur={handleBlur} value={values.app_store_url} />
                          <span className="text-danger">{errors.app_store_url && touched.app_store_url && errors.app_store_url}</span>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="text-left d-flex">Minimum Android Version:<span className="requirestar">*</span></label>
                          <input name="min_android_version" className="form-control" placeholder="e.g. 1.0.0" onChange={handleChange} onBlur={handleBlur} value={values.min_android_version} />
                          <span className="text-danger">{errors.min_android_version && touched.min_android_version && errors.min_android_version}</span>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="text-left d-flex">Current Android Version:<span className="requirestar">*</span></label>
                          <input name="current_android_version" className="form-control" placeholder="e.g. 1.2.0" onChange={handleChange} onBlur={handleBlur} value={values.current_android_version} />
                          <span className="text-danger">{errors.current_android_version && touched.current_android_version && errors.current_android_version}</span>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="text-left d-flex">Minimum IOS Version:<span className="requirestar">*</span></label>
                          <input name="min_ios_version" className="form-control" placeholder="e.g. 1.0.0" onChange={handleChange} onBlur={handleBlur} value={values.min_ios_version} />
                          <span className="text-danger">{errors.min_ios_version && touched.min_ios_version && errors.min_ios_version}</span>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="text-left d-flex">Current IOS Version:<span className="requirestar">*</span></label>
                          <input name="current_ios_version" className="form-control" placeholder="e.g. 1.2.0" onChange={handleChange} onBlur={handleBlur} value={values.current_ios_version} />
                          <span className="text-danger">{errors.current_ios_version && touched.current_ios_version && errors.current_ios_version}</span>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="text-left d-flex">Android Force Update:</label>
                          <div className="d-flex align-items-center">
                            <div className="form-check me-4">
                              <input type="radio" id="android_force_true" name="android_force_update" className="form-check-input" checked={values.android_force_update === true} onChange={() => setFieldValue("android_force_update", true)} />
                              <label className="form-check-label" htmlFor="android_force_true">True</label>
                            </div>
                            <div className="form-check">
                              <input type="radio" id="android_force_false" name="android_force_update" className="form-check-input" checked={values.android_force_update === false} onChange={() => setFieldValue("android_force_update", false)} />
                              <label className="form-check-label" htmlFor="android_force_false">False</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 form-group">
                          <label className="text-left d-flex">iOS Force Update:</label>
                          <div className="d-flex align-items-center">
                            <div className="form-check me-4">
                              <input type="radio" id="ios_force_true" name="ios_force_update" className="form-check-input" checked={values.ios_force_update === true} onChange={() => setFieldValue("ios_force_update", true)} />
                              <label className="form-check-label" htmlFor="ios_force_true">True</label>
                            </div>
                            <div className="form-check">
                              <input type="radio" id="ios_force_false" name="ios_force_update" className="form-check-input" checked={values.ios_force_update === false} onChange={() => setFieldValue("ios_force_update", false)} />
                              <label className="form-check-label" htmlFor="ios_force_false">False</label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            {t("label_copy_right_text")}:<span className="requirestar">*</span>
                          </label>
                          <input name="CopyRighttxt" className="form-control" onChange={handleChange} onBlur={handleBlur} value={values.CopyRighttxt} />
                          <span className="text-danger">{errors.CopyRighttxt && touched.CopyRighttxt && errors.CopyRighttxt}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            Title:<span className="requirestar">*</span>
                          </label>
                          <input name="title" className="form-control" onChange={handleChange} onBlur={handleBlur} value={values.title} />
                          <span className="text-danger">{errors.title && touched.title && errors.title}</span>
                        </div>
                        <div className="col-md-12 form-group">
                          <label className="text-left d-flex">
                            {t("label_is_buy_rent")}:
                          </label>
                          <div className="d-flex align-items-center">
                            <div className="form-check me-4">
                              <input
                                type="radio"
                                id="is_buy_rent_true"
                                name="is_buy_rent"
                                className="form-check-input"
                                checked={values.is_buy_rent === true}
                                onChange={() => setFieldValue("is_buy_rent", true)}
                              />
                              <label className="form-check-label" htmlFor="is_buy_rent_true">
                                True
                              </label>
                            </div>
                            <div className="form-check">
                              <input
                                type="radio"
                                id="is_buy_rent_false"
                                name="is_buy_rent"
                                className="form-check-input"
                                checked={values.is_buy_rent === false}
                                onChange={() => setFieldValue("is_buy_rent", false)}
                              />
                              <label className="form-check-label" htmlFor="is_buy_rent_false">
                                False
                              </label>
                            </div>
                          </div>
                        </div>

                        <label>{t("label_social_media")}:</label>
                        <FieldArray name="socialMedia">
                          {({ push, remove }) => (
                            <div className="col-12 mb-4">
                              <div className="row">
                                {values.socialMedia.map((friend, index) => (
                                  <div key={index} className="col-12 mb-2">
                                    <div className="w-100 p-2 bg-group">
                                      <div className="row">
                                        <div className="col-md-3">
                                          <Field name={`socialMedia.${index}.title`} placeholder={t("input_placeholder_title")} className="form-control" />
                                          <span className="text-danger">{errors.socialMedia?.[index]?.title}</span>
                                        </div>
                                        <div className="col-md-4">
                                          <Field name={`socialMedia.${index}.link`} placeholder={t("input_placeholder_link")} className="form-control" />
                                          <span className="text-danger">{errors.socialMedia?.[index]?.link}</span>
                                        </div>
                                        <div className="col-md-3">
                                          <Field name={`socialMedia.${index}.icon`} placeholder={t("input_placeholder_icon")} className="form-control" />
                                          <span className="text-danger">{errors.socialMedia?.[index]?.icon}</span>
                                        </div>
                                        <div className="col-md-2">
                                          <button type="button" className="btn btn-danger me-2" onClick={() => remove(index)} disabled={values.socialMedia.length === 1}>Remove</button>
                                          {index === values.socialMedia.length - 1 && (
                                            <button type="button" className="btn btn-primary" onClick={() => push({ title: '', link: '', icon: '' })}>Add</button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </FieldArray>

                        <label>Bae:</label>
                        <FieldArray name="baeMedia">
                          {({ push, remove }) => (
                            <div className="col-12 mb-4">
                              <div className="row">
                                {values.baeMedia.map((bae, index) => (
                                  <div key={index} className="col-12 mb-2">
                                    <div className="w-100 p-2 bg-group">
                                      <div className="row">
                                        <div className="col-md-10">
                                          <Field name={`baeMedia.${index}.title`} placeholder="Bae Title" className="form-control" />
                                          <span className="text-danger">{errors.baeMedia?.[index]?.title}</span>
                                        </div>
                                        <div className="col-md-2">
                                          <button type="button" className="btn btn-danger me-2" onClick={() => remove(index)} disabled={values.baeMedia.length === 1}>Remove</button>
                                          {index === values.baeMedia.length - 1 && (
                                            <button type="button" className="btn btn-primary" onClick={() => push({ title: "" })}>Add</button>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                        </FieldArray>

                        <button type="submit" className="btn btn-main-primary signbtn" disabled={submitted}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default GlobalSettings;

